<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
            <label > Icare List </label>
            <div v-for="i in icare" :key="i.id">
            <input type="checkbox"  :value="`${i.id}`" v-model="form.icare_id">
            {{ i.name }}
            </div>
          </CCol> 
          </CRow>
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="updateIcare(form.id, form.icare_id)"  variant="outline" color="info">Update</CButton>
      </template>
    </CModal>
  </form>

</template>

<script>
import axios from 'axios'
import EventBus from '@/eventBus';

import icare from '@/services/icareyouth'
import member from '@/services/member'
import group from '@/services/coachgroupyouth'

export default {
name: 'icaremodal',
components: { },
  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      form:{
        id:'',
        icare_id:[],
      },
      icare:[],
    }
  },
  mounted (){
     this.load()

      EventBus.$on('PAGE_UPDATE', (data) => {
      if(data){
          this.load();
      }
    });
   },
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_MANAGE_ICARE', (params) => {
      if(params.data){
        icare.getIcarebyID(params.data)
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.id = res.data.id;
          self.form.name = res.data.name;
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.name = "";
      }
    });
    this.form.id = this.$route.query.Pud
  },
   mounted (){
     this.loadData()
   },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    
    loadData() {
      icare.getIcare()
      .then(res => {
          let getData = res
          this.icare = getData.data
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })

      group.getGroupbyID(this.$route.query.Pud)
      .then(res => {
          let getData = res
          for (var i = 0; i < getData.data.icare.length; i++) {
            this.form.icare_id.push(getData.data.icare[i].id);
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })

    },
    updateIcare(id,icare_id){
      this.show = false;
      if(confirm("Do you really want to change your icare group?")){
          var param = {
            icare_id: icare_id,
          }
           console.log(id, param)
          group.updateIcare(id, param)
          .then(res => {
            //this.load()
            EventBus.$emit('PAGE_UPDATE', true)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
        }
    },
    load(){
     group.getGroupbyID(this.$route.query.Pud)
      .then(res => {
      this.datas =res
     
      })
    },
  }
}
</script>

<style>

</style>